import { Theme, makeStyles } from '@material-ui/core/styles';
import {
  omakaseBoxShadowTokensLight,
  omakaseColorTokensLight,
  omakaseTypographyTokens,
} from 'theme/themeCssVariables';

const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    ':root': {
      /**
       * See comment within themeCssVariables.ts - the following portion should be revisited when further adoption of CSS custom properties takes place.
       */
      // ...durationTokens,

      // '@media (prefers-reduced-motion)': {
      //   ...durationTokensReducedMotion,
      // },

      '@media (prefers-color-scheme: light)': {
        ...omakaseColorTokensLight,
        ...omakaseBoxShadowTokensLight,
      },
      '@media (prefers-color-scheme: dark)': {
        ...omakaseColorTokensLight,
        ...omakaseBoxShadowTokensLight,
      },

      ...omakaseTypographyTokens,
    },
    // display main as block by default for ie11
    main: {
      display: 'block',
    },
    '.TockWidgetBody': {
      backgroundColor: 'transparent',
    },
    '#skip': {
      '& a': {
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        padding: 16,
        '&:focus': {
          left: 8,
          zIndex: 10000,
          top: 8,
          backgroundColor: theme.colors.bgDefault,
          width: 'auto',
          height: 'auto',
        },
      },
    },
    '::placeholder': {
      color: `${theme.colors.fgSubtle} !important`,
      opacity: '1 !important',
    },
    '::-webkit-input-placeholder': {
      /* Chrome/Opera/Safari */ color: `${theme.colors.fgSubtle} !important`,
      opacity: '1 !important',
    },
    '::-moz-placeholder': {
      /* Firefox 19+ */ color: `${theme.colors.fgSubtle} !important`,
      opacity: '1 !important',
    },
    ':-ms-input-placeholder': {
      /* IE 10+ */ color: `${theme.colors.fgSubtle} !important`,
      opacity: '1 !important',
    },
    ':-moz-placeholder': {
      /* Firefox 18- */ color: `${theme.colors.fgSubtle} !important`,
      opacity: '1 !important',
    },
  },
}));

export default function GlobalStyles() {
  useStyles();

  return null;
}
